import axiosInstance from "../../services/axiosInstance";
import {
  normalizeBlobAPIError,
  throwIfBlobContainsAPIData,
} from "../../services/blob-response";
//////// 轉換下拉式選單資料格式
const formatter = (list = []) =>
  list
    .map((item) => {
      // 取出依插入順序排列的鍵
      const keys = Object.keys(item);
      if (keys.length < 2) return null; // 目的：防呆，至少要兩個鍵

      const [valueKey, labelKey, specialKey] = keys; // 目的：抓前兩個鍵
      return {
        label: item[labelKey], // 目的：前鍵的值當 label
        value: item[valueKey], // 目的：後鍵的值當 value
        ...(specialKey
          ? { [specialKey]: item[specialKey] ?? "" } // ✅ 動態鍵名要用 [specialKey]
          : {}),
      };
    })
    .filter(Boolean); // 目的：移除不合法項目（鍵不足）

export const emissionFactorAPI = {
  //////// cat1 cat2修改排放活動頁面的Modal的修改排放係數
  async modifyEF(cat, EFFormData) {
    const requestBody = {
      emissionFactorTypeId: Number(EFFormData?.emissionFactorTypeId),
      emissionFactorId: Number(EFFormData?.emissionFactorId),
    };

    //////// 4.4 5.1 5.2 5.3 system 底下的 Custom 選項
    if (EFFormData?.computationMethodOrEnergySource4_4 === "Renewable Energy") {
      requestBody.emissionFactorTypeId = 2;
      requestBody.useCustomEFLevel = true;
    }

    if (EFFormData?.energyType5_1 === "Renewable Energy") {
      requestBody.emissionFactorTypeId = 2;
      requestBody.useCustomEFLevel = 51000000001;
    }

    if (EFFormData?.energyType5_1 === "Others") {
      requestBody.emissionFactorTypeId = 2;
      requestBody.useCustomEFLevel = 51000000000;
    }

    if (EFFormData?.emissionSource5_2 === "Renewable Energy") {
      requestBody.emissionFactorTypeId = 2;
      requestBody.useCustomEFLevel = 52000000000;
    }

    try {
      const response = await axiosInstance.put(
        `/api/${cat}/emission_factor/${EFFormData?.id}`,
        requestBody,
      );

      return response.data;
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error Modify Emission Factor");

      throw err;
    }
  },

  ////////修改cat4_3排放活動頁面的Modal的修改排放係數
  async cat4_3modifyEF(
    id,
    emissionFactorTypeId,
    emissionFactorId,
    landEFTypeId,
    landEFId,
  ) {
    try {
      const response = await axiosInstance.put(
        `/api/cat4/emission_factor/${id}`,
        {
          emissionFactorTypeId: Number(emissionFactorTypeId) || 0,
          emissionFactorId: Number(emissionFactorId) || 0,
          landEFTypeId: Number(landEFTypeId) || 0,
          landEFId: Number(landEFId) || 0,
        },
      );
      return response.data;
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error Modify Emission Factor");

      throw err;
    }
  },

  ////////通用層級下拉式選單
  async emissionLevel(requestBody) {
    const response = await axiosInstance.post(
      `/api/ef/get_ef_level_option`,
      requestBody,
    );
    return response.data.data;
  },

  ////////通用量化方法
  async quantitativeDropdown() {
    return [{ label: "量化方法", value: "0" }];
  },

  ////////通用排放係數選用
  async emissionFactorDropdown() {
    return [
      { label: "System Database", value: "1" },
      { label: "Custom Emission Factor", value: "2" },
    ];
  },

  ////////6_1只有Custom
  async emissionFactorDropdown6_1() {
    return [{ label: "Custom Emission Factor", value: 2 }];
  },

  ////////通用EF詳細資料
  async EFDec(cat, EFTId, EFId) {
    try {
      const response = await axiosInstance.get(
        `/api/${cat}/emission_factor/content/${EFId}/${EFTId}`,
      );

      return response.data.data;
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error fetching EF Decription");
    }
  },

  ////////五六通用EF詳細資料
  async EFDecSpecial(cat, EFId) {
    try {
      const response = await axiosInstance.get(
        `/api/${cat}/emission_factor/content/${EFId}`,
      );

      return response.data.data;
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error fetching EF Decription");
    }
  },

  ////////排放係數修改檢查
  async modifyEFCheck(cat, requestBody) {
    try {
      const response = await axiosInstance.post(
        `/api/${cat}/validate_EF_unit`,
        requestBody,
      );

      return response.data.data;
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error checking modify EF");
    }
  },

  //////// EF通用排放係數列表 (services版本)
  async getEFList(requestBody, catName) {
    const res = await axiosInstance.post(
      `/api/${catName}/emission_factor/list`,
      requestBody,
    );
    return res.data.data;
  },

  //////// EF排放係數 biomass (services版本)
  async getBiomassEFList(requestBody, catName) {
    const res = await axiosInstance.post(
      `/api/${catName}/emission_factor/list/biomass`,
      requestBody,
    );
    return res.data.data;
  },

  ////////1.1 EFlist
  async cat1_1EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "1_1",
      keyword: keyword,
    };

    // 如果是生質能，用 biomass 版本 API
    const url = isBiomass
      ? "/api/cat1/emission_factor/list/biomass"
      : "/api/cat1/emission_factor/list";

    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// Scope1 係數資料庫下拉式選單
  async cat1SourceDropdownList(cat) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/source_dropdown_list/${cat}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.sourceEFId,
        label: item.sourceEFName,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope1 排放源類別下拉式選單
  async cat1SourceLevelDropdownList(category, unitCategoryId, sourceEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/source_level_dropdown_list/${category}/${unitCategoryId}/${sourceEFId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionLevelId,
        label: item.emissionLevel,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope1 排放係數名稱下拉式選單
  async cat1EmissionFactorNameDropdownList(
    category,
    unitCategoryId,
    sourceEFId,
    emissionLevelId,
  ) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/dropdown_list/${category}/${unitCategoryId}/${sourceEFId}/${emissionLevelId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionFactorId,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "取得排放係數名稱下拉式選單錯誤");
      console.error("取得排放係數名稱下拉式選單錯誤 :", err);
      return [];
    }
  },

  //////// Scope1 修改排放活動的排放係數
  async cat1ModifyEmissionFactor(id, emissionFactorTypeId, emissionFactorId) {
    const requestBody = {
      emissionFactorTypeId: emissionFactorTypeId || null,
      emissionFactorId: Number(emissionFactorId) || null,
    };

    try {
      const response = await axiosInstance.put(
        `/api/cat1/emission_factor/${id}`,
        requestBody,
      );
      return response.data;
    } catch (err) {
      // handleAPIError(err, "Error modify list");
      console.error("Error modify list", err);
      throw err;
    }
  },

  //////// cat1 自定義排放係數下拉式選單
  ////新版自定義排放係數下拉式選單
  async cat1CustomEFDropdownList(cId, cat, standardId) {
    if (!cId) {
      return [
        {
          label: "Please fill in company field first.",
          value: "none",
        },
      ];
    }
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/custom_dropdown_list/${cId}/${cat}?standardId=${standardId}`,
      );

      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error fetching custom dorpdown list");
    }
  },

  ////////ddddddddddddddddddddddddddddddddddddddd
  async cat1CustomEmissionFactorDropdownList(cId, cat, unitCategoryId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/custom_dropdown_list_old/${cId}/${cat}/${unitCategoryId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope1 EF詳細資料
  async cat1EFDec(emissionFactorId, emissionFactorTypeId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/content/${emissionFactorId}/${emissionFactorTypeId}`,
      );
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "Error fetching EF Decription");
      console.error("Error fetching EF Decription");
      return null;
    }
  },

  //////// Scope1 質量平衡排放係數下拉式選單
  async cat1MassBalanceDropdownList(cId, cat) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/mass_balance_dropdown_list/${cat}?companyId=${cId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionFactorId,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching massBalance dropdown list");
      console.error("Error fetching massBalance dropdown list");
      return null;
    }
  },

  ////////1.2 EFlist
  async cat1_2EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "1_2",
      keyword: keyword,
    };
    // 如果是生質能，用 biomass 版本 API
    const url = isBiomass
      ? "/api/cat1/emission_factor/list/biomass"
      : "/api/cat1/emission_factor/list";

    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  async computation() {
    return [
      { label: "Fuel Based", value: "0" },
      { label: "Distance Based", value: "1" },
    ];
  },

  ////////1.2 排放源類別下拉式選單
  async cat1_2SourceLevelDropdownList(category, unitCategoryId, sourceEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/source_level_dropdown_list/${category}/${unitCategoryId}/${sourceEFId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionLevelId,
        label: item.emissionLevel,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  ////////1.2 排放係數名稱下拉式選單
  async cat1_2EmissionFactorNameDropdownList(
    unitCategoryId,
    sourceEFId,
    emissionLevelId,
  ) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/dropdown_list/${unitCategoryId}/${sourceEFId}/${emissionLevelId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionFactorId,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "取得排放係數名稱下拉式選單錯誤");
      console.error("取得排放係數名稱下拉式選單錯誤 :", err);
      return [];
    }
  },

  ////////1.3 EFlist
  async cat1_3EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "1_3",
      keyword: keyword,
    };
    // 如果是生質能，用 biomass 版本 API
    const url = isBiomass
      ? "/api/cat1/emission_factor/list/biomass"
      : "/api/cat1/emission_factor/list";

    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////1.3 排放源類別下拉式選單
  async cat1_3SourceLevelDropdownList(unitCategoryId, sourceEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/source_level_dropdown_list/${unitCategoryId}/${sourceEFId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionLevelId,
        label: item.emissionLevel,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  ////////1.3 排放係數名稱下拉式選單
  async cat1_3EmissionFactorNameDropdownList(
    unitCategoryId,
    sourceEFId,
    emissionLevelId,
  ) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/dropdown_list/${unitCategoryId}/${sourceEFId}/${emissionLevelId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionFactorId,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "取得排放係數名稱下拉式選單錯誤");
      console.error("取得排放係數名稱下拉式選單錯誤 :", err);
      return [];
    }
  },

  ////////1.4 EFlist
  async cat1_4EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "1_4",
      keyword: keyword,
    };
    // 如果是生質能，用 biomass 版本 API
    const url = isBiomass
      ? "/api/cat1/emission_factor/list/biomass"
      : "/api/cat1/emission_factor/list";

    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////1.4 排放源類別下拉式選單
  async cat1_4SourceLevelDropdownList(unitCategoryId, sourceEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/source_level_dropdown_list/${unitCategoryId}/${sourceEFId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionLevelId,
        label: item.emissionLevel,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  ////////1.4 排放係數名稱下拉式選單
  async cat1_4EmissionFactorNameDropdownList(
    unitCategoryId,
    sourceEFId,
    emissionLevelId,
  ) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/emission_factor/dropdown_list/${unitCategoryId}/${sourceEFId}/${emissionLevelId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionFactorId,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "取得排放係數名稱下拉式選單錯誤");
      console.error("取得排放係數名稱下拉式選單錯誤 :", err);
      return [];
    }
  },

  ////////1.5 EFlist
  async cat1_5EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "1_5",
      keyword: keyword,
    };
    // 如果是生質能，用 biomass 版本 API
    const url = isBiomass
      ? "/api/cat1/emission_factor/list/biomass"
      : "/api/cat1/emission_factor/list";

    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// cat2 自定義下拉式選單
  async cat2CustomEFDropdownList(cId, cat, standardId) {
    if (!cId) {
      return [
        {
          label: "Please fill in company field first.",
          value: "none",
        },
      ];
    }
    try {
      const response = await axiosInstance.get(
        `/api/cat2/emission_factor/custom_dropdown_list/${cId}/${cat}?standardId=${standardId}`,
      );

      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error fetching custom dorpdown list");
    }
  },

  //////// cat2 係數資料庫下拉式選單
  async cat2SourceDropdownList(cat) {
    try {
      const response = await axiosInstance.get(
        `/api/cat2/emission_factor/source_dropdown_list/${cat}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.sourceEFId,
        label: item.sourceEFName,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// cat2 排放源類別下拉式選單
  async cat2SourceLevelDropdownList(category, unitCategoryId, sourceEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat2/emission_factor/source_level_dropdown_list/${category}/${unitCategoryId}/${sourceEFId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionLevelId,
        label: item.emissionLevel,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// cat2 排放係數名稱下拉式選單
  async cat2EmissionFactorNameDropdownList(
    category,
    unitCategoryId,
    sourceEFId,
    emissionLevelId,
  ) {
    try {
      const response = await axiosInstance.get(
        `/api/cat2/emission_factor/dropdown_list/${category}/${unitCategoryId}/${sourceEFId}/${emissionLevelId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionFactorId,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "取得排放係數名稱下拉式選單錯誤");
      console.error("取得排放係數名稱下拉式選單錯誤 :", err);
      return [];
    }
  },

  //////// cat2 自定義排放係數下拉式選單
  async cat2CustomEmissionFactorDropdownList(cId, cat, unitCategoryId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat2/emission_factor/custom_dropdown_list_old/${cId}/${cat}/${unitCategoryId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// cat2 EF詳細資料
  async cat2EFDec(emissionFactorId, emissionFactorTypeId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat2/emission_factor/content/${emissionFactorId}/${emissionFactorTypeId}`,
      );
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "Error fetching EF Decription");
      console.error("Error fetching EF Decription", err);
    }
  },

  //////// cat2 修改排放活動的排放係數
  async cat2ModifyEmissionFactor(id, emissionFactorTypeId, emissionFactorId) {
    const requestBody = {
      emissionFactorTypeId: emissionFactorTypeId,
      emissionFactorId: Number(emissionFactorId),
    };
    try {
      const response = await axiosInstance.put(
        `/api/cat2/emission_factor/${id}`,
        requestBody,
      );
      return response.data;
    } catch (err) {
      // handleAPIError(err, "Error modify list");
      console.error("Error modify list", err);
      throw err;
    }
  },

  ////////2.1 EFlist
  async cat2_1EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "2_1",
      keyword: keyword,
    };
    // 如果是生質能，用 biomass 版本 API
    const url = isBiomass
      ? "/api/cat2/emission_factor/list/biomass"
      : "/api/cat2/emission_factor/list";

    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////2.2 EFlist
  async cat2_2EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "2_2",
      keyword: keyword,
    };
    // 如果是生質能，用 biomass 版本 API
    const url = isBiomass
      ? "/api/cat2/emission_factor/list/biomass"
      : "/api/cat2/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// cat3 自定義下拉式選單
  async cat3CustomEFDropdownList(cId, cat, standardId) {
    if (!cId) {
      return [
        {
          label: "Please fill in company field first.",
          value: "none",
        },
      ];
    }
    try {
      const response = await axiosInstance.get(
        `/api/cat3/emission_factor/custom_dropdown_list/${cId}/${cat}?standardId=${standardId}`,
      );

      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error fetching custom dorpdown list");
    }
  },

  ////////3.1 EFlist
  async cat3_1EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "3_1",
      keyword: keyword,
    };
    // 如果是生質能，用 biomass 版本 API
    const url = isBiomass
      ? "/api/cat3/emission_factor/list/biomass"
      : "/api/cat3/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// Scope3 係數資料庫下拉式選單
  async cat3SourceDropdownList(cat) {
    try {
      const response = await axiosInstance.get(
        `/api/cat3/emission_factor/source_dropdown_list/${cat}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.sourceEFId,
        label: item.sourceEFName,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope3 排放源類別下拉式選單
  async cat3SourceLevelDropdownList(category, unitCategoryId, sourceEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat3/emission_factor/source_level_dropdown_list/${category}/${unitCategoryId}/${sourceEFId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionLevelId,
        label: item.emissionLevel,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope3 排放係數名稱下拉式選單
  async cat3EmissionFactorNameDropdownList(
    category,
    unitCategoryId,
    sourceEFId,
    emissionLevelId,
  ) {
    try {
      const response = await axiosInstance.get(
        `/api/cat3/emission_factor/dropdown_list/${category}/${unitCategoryId}/${sourceEFId}/${emissionLevelId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionFactorId,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "取得排放係數名稱下拉式選單錯誤");
      console.error("取得排放係數名稱下拉式選單錯誤 :", err);
      return [];
    }
  },

  ///////////ddddddddddddddddddddddddddddddddddddddddddd
  //////// Scope3 自定義排放係數下拉式選單
  async cat3CustomEmissionFactorDropdownList(cId, cat, unitCategoryId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat3/emission_factor/custom_dropdown_list/${cId}/${cat}/${unitCategoryId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope3 EF詳細資料
  async cat3EFDec(emissionFactorId, emissionFactorTypeId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat3/emission_factor/content/${emissionFactorId}/${emissionFactorTypeId}`,
      );
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "Error fetching EF Decription");
      console.error("Error fetching EF Decription");
    }
  },

  //////// Scope3 修改排放活動的排放係數
  async cat3ModifyEmissionFactor(id, EFTypeId, EFId) {
    const requestBody = {
      emissionFactorTypeId: EFTypeId || null,
      emissionFactorId: EFId || null,
    };
    try {
      const response = await axiosInstance.put(
        `/api/cat3/emission_factor/${id}`,
        requestBody,
      );
      return response.data;
    } catch (err) {
      // handleAPIError(err, "Error modify list");
      console.error("Error modify list", err);
      throw err;
    }
  },

  ////////3.2 EFlist
  async cat3_2EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "3_2",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat3/emission_factor/list/biomass"
      : "/api/cat3/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////3.3 EFlist
  async cat3_3EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "3_3",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat3/emission_factor/list/biomass"
      : "/api/cat3/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////3.4 EFlist
  async cat3_4EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "3_4",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat3/emission_factor/list/biomass"
      : "/api/cat3/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////3.5 EFlist
  async cat3_5EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "3_5",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat3/emission_factor/list/biomass"
      : "/api/cat3/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// cat4 自定義下拉式選單
  async cat4CustomEFDropdownList(cId, cat, standardId) {
    if (!cId) {
      return [
        {
          label: "Please fill in company field first.",
          value: "none",
        },
      ];
    }
    try {
      const response = await axiosInstance.get(
        `/api/cat4/emission_factor/custom_dropdown_list/${cId}/${cat}?standardId=${standardId}`,
      );

      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error fetching custom dorpdown list");
    }
  },

  ////////4.1 EFlist
  async cat4_1EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "4_1",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat4/emission_factor/list/biomass"
      : "/api/cat4/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// Scope4 係數資料庫下拉式選單
  async cat4SourceDropdownList(cat) {
    try {
      const response = await axiosInstance.get(
        `/api/cat4/emission_factor/source_dropdown_list/${cat}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.sourceEFId,
        label: item.sourceEFName,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope4 排放源類別下拉式選單
  async cat4SourceLevelDropdownList(category, unitCategoryId, sourceEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat4/emission_factor/source_level_dropdown_list/${category}/${unitCategoryId}/${sourceEFId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionLevelId,
        label: item.emissionLevel,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope4 排放係數名稱下拉式選單
  async cat4EmissionFactorNameDropdownList(
    category,
    unitCategoryId,
    sourceEFId,
    emissionLevelId,
  ) {
    try {
      const response = await axiosInstance.get(
        `/api/cat4/emission_factor/dropdown_list/${category}/${unitCategoryId}/${sourceEFId}/${emissionLevelId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.emissionFactorId,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "取得排放係數名稱下拉式選單錯誤");
      console.error("取得排放係數名稱下拉式選單錯誤 :", err);
      return [];
    }
  },

  //////// Scope4 自定義排放係數下拉式選單

  async cat4CustomEmissionFactorDropdownList(cId, cat, unitCategoryId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat4/emission_factor/custom_dropdown_list/${cId}/${cat}/${unitCategoryId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope4 EF詳細資料
  async cat4EFDec(emissionFactorId, emissionFactorTypeId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat4/emission_factor/content/${emissionFactorId}/${emissionFactorTypeId}`,
      );
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "Error fetching EF Decription");
      console.error("Error fetching EF Decription", err);
    }
  },

  //////// Scope4 修改排放活動的排放係數

  async cat4ModifyEmissionFactor(
    id,
    emissionFactorTypeId,
    emissionFactorId,
    landEFTypeId,
    landEFId,
  ) {
    const requestBody = {
      emissionFactorTypeId: Number(emissionFactorTypeId) || 0,
      emissionFactorId: Number(emissionFactorId) || 0,
      landEFTypeId: Number(landEFTypeId) || 0,
      landEFId: Number(landEFId) || 0,
    };
    try {
      const response = await axiosInstance.put(
        `/api/cat4/emission_factor/${id}`,
        requestBody,
      );
      return response.data;
    } catch (err) {
      // handleAPIError(err, "Error modify list");
      console.error("Error modify list", err);
      throw err;
    }
  },

  ////////4.2 EFlist
  async cat4_2EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "4_2",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat4/emission_factor/list/biomass"
      : "/api/cat4/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////4.3 EFlist
  async cat4_3EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "4_3",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat4/emission_factor/list/biomass"
      : "/api/cat4/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////4.4 EFlist
  async cat4_4EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "4_4",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat4/emission_factor/list/biomass"
      : "/api/cat4/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////4.5 EFlist
  async cat4_5EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "4_5",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat4/emission_factor/list/biomass"
      : "/api/cat4/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// cat5 計算方法
  async cat5Calculation(cat) {
    try {
      const response = await axiosInstance.get(
        `/api/cat5/calculation_dropdown_list/${cat}`,
      );

      return formatter(response.data.data);
    } catch (error) {
      // handleAPIError(error, "Error fetching Calculation dropdown list");
      console.error("Error fetching data:", error);
      return null; // 失敗時回傳 null
    }
  },

  //////// cat5 自定義下拉式選單
  async cat5CustomEFDropdownList(cId, cat, standardId) {
    if (!cId) {
      return [
        {
          label: "Please fill in company field first.",
          value: "none",
        },
      ];
    }
    try {
      const response = await axiosInstance.get(
        `/api/cat5/emission_factor/custom_dropdown_list/${cId}/${cat}?standardId=${standardId}`,
      );

      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error fetching custom dorpdown list");
    }
  },

  ////////5.1 EFlist
  async cat5_1EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "5_1",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat5/emission_factor/list/biomass"
      : "/api/cat5/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// Scope5 自定義排放係數下拉式選單

  async cat5CustomEmissionFactorDropdownList(cId, cat, unitCategoryId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat5/emission_factor/custom_dropdown_list/${cId}/${cat}/${unitCategoryId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope5 EF詳細資料
  async cat5EFDec(emissionFactorId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat5/emission_factor/content/${emissionFactorId}`,
      );
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "Error fetching EF Decription");
      console.error("Error fetching EF Decription", err);
    }
  },

  //////// Scope5 修改排放活動的排放係數

  async cat5ModifyEmissionFactor(id, emissionFactorTypeId, emissionFactorId) {
    const requestBody = {
      emissionFactorTypeId: Number(emissionFactorTypeId) || 0,
      emissionFactorId: Number(emissionFactorId) || 0,
    };
    try {
      const response = await axiosInstance.put(
        `/api/cat5/emission_factor/${id}`,
        requestBody,
      );
      return response.data;
    } catch (err) {
      // handleAPIError(err, "Error modify list");
      console.error("Error modify list", err);
      throw err;
    }
  },

  ////////5.2 EFlist
  async cat5_2EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "5_2",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat5/emission_factor/list/biomass"
      : "/api/cat5/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////5.3 EFlist
  async cat5_3EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "5_3",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat5/emission_factor/list/biomass"
      : "/api/cat5/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////5.4 EFlist
  async cat5_4EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "5_4",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat5/emission_factor/list/biomass"
      : "/api/cat5/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  ////////6.1 EFlist
  async cat6_1EmissionFactorList(cId, year, keyword, isBiomass) {
    const requestBody = {
      companyIds: cId,
      year: year,
      category: "6_1",
      keyword: keyword,
    };
    const url = isBiomass
      ? "/api/cat6/emission_factor/list/biomass"
      : "/api/cat6/emission_factor/list";
    try {
      const response = await axiosInstance.post(url, requestBody);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching list");
      console.error("Error fetching list", error);
      return [];
    }
  },

  //////// Scope6 自定義排放係數下拉式選單

  async cat6CustomEmissionFactorDropdownList(cId, cat, unitCategoryId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat6/emission_factor/custom_dropdown_list/${cId}/${cat}/${unitCategoryId}`,
      );
      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      // handleAPIError(err, "Error fetching list");
      console.error("Error fetching list", err);
      return [];
    }
  },

  //////// Scope6 EF詳細資料
  async cat6EFDec(emissionFactorId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat6/emission_factor/content/${emissionFactorId}`,
      );
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "Error fetching EF Decription");
      console.error("Error fetching EF Decription", err);
    }
  },

  //////// Scope6 修改排放活動的排放係數

  async cat6ModifyEmissionFactor(id, emissionFactorTypeId, emissionFactorId) {
    const requestBody = {
      emissionFactorTypeId: Number(emissionFactorTypeId) || 0,
      emissionFactorId: Number(emissionFactorId) || 0,
    };
    try {
      const response = await axiosInstance.put(
        `/api/cat6/emission_factor/${id}`,
        requestBody,
      );
      return response.data;
    } catch (err) {
      // handleAPIError(err, "Error modify list");
      console.error("Error modify list", err);
      throw err;
    }
  },

  //////// cat1 自定義排放係數下拉式選單
  ////新版自定義排放係數下拉式選單
  async cat6CustomEFDropdownList(cId, cat, standardId) {
    if (!cId) {
      return [
        {
          label: "Please fill in company field first.",
          value: "none",
        },
      ];
    }
    try {
      const response = await axiosInstance.get(
        `/api/cat6/emission_factor/custom_dropdown_list/${cId}/${cat}?standardId=${standardId}`,
      );

      ////////轉成Selector格式
      return response.data.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.nameEF,
      }));
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "Error fetching custom dorpdown list");
    }
  },

  ////////取得單一排放活動的資料
  ////取前綴跟後綴
  extractPrefixAndSuffix(category) {
    const index = category.indexOf("_"); // 找到第一個 `_` 的索引
    if (index === -1) return { prefix: category, suffix: "" }; // 沒有 `_` 則 suffix 為空字串

    return {
      prefix: category.slice(0, index), // 取 `cat1` 前的部分
      suffix: category.slice(index - 1), // 取 `1_1` 後的所有部分
    };
  },

  ////////拿到某一筆排放係數
  async editEmissionFactorAPI(catName, cat, id) {
    const response = await axiosInstance.get(
      `/api/${catName}/emission_factor/${id}/${cat}`,
    );
    let data = response.data.data;
    return data;
  },

  async getEmissionFactorDetail(id, category) {
    const { prefix, suffix } =
      emissionFactorAPI.extractPrefixAndSuffix(category);
    try {
      const response = await axiosInstance.get(
        `/api/${prefix}/emission_factor/${id}/${suffix}`,
      );
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "Error fetching Emission Factor Detail");
      console.error("Error fetching Emission Factor Detail", err);
      return [];
    }
  },

  ////////下載排放係數Excel
  async downloadEmissionFactorExcel(requestBody) {
    try {
      const response = await axiosInstance.post(
        `/api/ef/export_customo_data`,
        requestBody,
        {
          responseType: "blob", // 設定回應類型為 Blob，確保能接收二進制檔案
          timeout: 300000,
        },
      );
      await throwIfBlobContainsAPIData(response);
      // 創建 Blob 物件
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // 創建下載連結
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"];
      const matchFileName = contentDisposition.match(/filename="?([^"]+)"?/);
      link.href = downloadUrl;
      link.setAttribute("download", `${matchFileName[1]}`); // 設定下載的檔名
      document.body.appendChild(link);
      link.click(); // 自動點擊下載
      document.body.removeChild(link); // 下載後移除連結
      window.URL.revokeObjectURL(downloadUrl);
      return response;
    } catch (err) {
      console.error("Error downloading Excel", err);
      await normalizeBlobAPIError(err);
      throw err;
    }
  },

  ////////上傳排放係數Excel
  async uploadEmissionFactorExcel(formData) {
    try {
      const response = await axiosInstance.post(
        `/api/ef/import_customo_data`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // 確保 Content-Type 正確
          },
        },
      );
    } catch (err) {
      // handleAPIError(err, "Error uploading Excel");
      console.error("Error uploading Excel", err);
      throw err;
    }
  },

  ////////驗證輸入EF可不可用的API
  async checkEFAvailable(cat, activityNameId, companyId, emissionFactorId) {
    try {
      const response = await axiosInstance.get(
        `/api/cat1/get_Emission_Factor_info/?category=${cat}&activityNameId=${activityNameId}&companyId=${companyId}&emissionFactorId=${emissionFactorId}`,
      );
      return response.data;
    } catch (err) {
      // handleAPIError(err, "Error checking EF availability");
      console.error("Error checking EF availability", err);
    }
  },

  ////////EF驗證頁面修改排放活動的排放係數
  ////////delete
  async modifyEmissionFactor(cat, id, emissionFactorTypeId, emissionFactorId) {
    const requestBody = {
      emissionFactorTypeId: emissionFactorTypeId || null,
      emissionFactorId: Number(emissionFactorId) || null,
    };

    try {
      const response = await axiosInstance.put(
        `/api/${cat}/emission_factor/${id}`,
        requestBody,
      );
    } catch (err) {
      // handleAPIError(err, "Error modify list");
      console.error("Error modify list", err);
      return [];
    }
  },

  ///透過 EF 取得單位下拉式選單
  async getUnitListFromEF(efTypeId, efId) {
    try {
      const response =
        await axiosInstance.get(`/api/ef/get_units_dropdown_list_from_EF/${efTypeId}/${efId}
`);
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "Error get Unit List From EF");
      console.error("Error get Unit List From EF", err);
    }
  },
};
